import { CreateNewPassword } from "./CreateNewPassword";

export {
  CreateNewPassword,
  CreateNewPasswordWithoutCommercePlatform
} from "./CreateNewPassword";
export default CreateNewPassword;
